import {
  ApplicationContext,
  ApplicationContextState
} from '@/store/modules/application-context/types/application-context.types';

export const applicationContextMutations = {
  SET_APPLICATION_CONTEXT(
    state: ApplicationContextState,
    payload: ApplicationContext
  ) {
    state.applicationContext = payload;
  }
};
